export default "__VITE_ASSET__e596ee48__"